/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationForServiceNowRequestManagement extends models.GovernanceConfigurationBaseForServiceNow {
    constructor() {
        super();
        this.setDiscriminator("GovernanceConfigurationForServiceNowRequestManagement");
    }

    getFixupPrototypeFunction() { return GovernanceConfigurationForServiceNowRequestManagement.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationForServiceNowRequestManagement>): GovernanceConfigurationForServiceNowRequestManagement {
        let obj = Object.assign(new GovernanceConfigurationForServiceNowRequestManagement(), model);
        GovernanceConfigurationForServiceNowRequestManagement.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationForServiceNowRequestManagement>): GovernanceConfigurationForServiceNowRequestManagement {
        if (!model) return null;
        return GovernanceConfigurationForServiceNowRequestManagement.newInstance(<GovernanceConfigurationForServiceNowRequestManagement> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationForServiceNowRequestManagement) {
        if (!obj) return;

        models.GovernanceConfigurationForServiceNowRequestManagement.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationForServiceNowRequestManagement): boolean {
        if (models.GovernanceConfigurationBaseForServiceNow.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationForServiceNowRequestManagement.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.request_attribute_mapping) {
            for (let val of this.request_attribute_mapping) {
                models.ServiceNowRequestManagementAttributeMapping.fixupPrototype(val);
            }
        }
        if (this.action_mapping) {
            for (let val of this.action_mapping) {
                models.ServiceNowRequestManagementActionMapping.fixupPrototype(val);
            }
        }
        if (this.status_mapping) {
            for (let val of this.status_mapping) {
                models.ServiceNowRequestManagementStatusMapping.fixupPrototype(val);
            }
        }
        if (this.catalog_details) {
            for (let val of this.catalog_details) {
                models.ServiceNowRequestManagementCatalogDetails.fixupPrototype(val);
            }
        }
    }

    /**
     * List of Request numbers for Request Management
     */
    request_attribute: Array<string>;

    request_attribute_mapping: Array<models.ServiceNowRequestManagementAttributeMapping>;

    action_mapping: Array<models.ServiceNowRequestManagementActionMapping>;

    status_mapping: Array<models.ServiceNowRequestManagementStatusMapping>;

    catalog_details: Array<models.ServiceNowRequestManagementCatalogDetails>;

}
